/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { useMediaQuery, useTheme } from "@mui/material";
import { useSelector } from "react-redux";
import { Navigate, RouteObject, useRoutes } from "react-router-dom";

import { ACCOUNT_ROUTES } from "../../features/account/constants";
import UserAccountScreen from "../../features/account/pages/UserAccount/UserAccountScreen";
import { selectIsCEUser } from "../../features/azure-b2c/storage";
import CELinkNoAccess from "../../pages/CELinkNoAccess";
import NoAccess from "../../pages/NoAccess";
import { HOME_ROUTE, LOGOUT_CE_USER_ROUTE, LOGOUT_ROUTE } from "../../util/routing";

import Logout from "./Logout";
import LogoutCEUser from "./LogoutCEUser";

const NoAccessRoutes = () => {
  const isCEUser = useSelector(selectIsCEUser);
  const theme = useTheme();
  const isMobileSize = useMediaQuery(theme.breakpoints.down("md"));

  const routes: RouteObject[] = [
    {
      path: "/",
      children: [
        { path: LOGOUT_ROUTE, element: <Logout /> },
        { path: LOGOUT_CE_USER_ROUTE, element: <LogoutCEUser /> },
        { path: HOME_ROUTE, element: isCEUser ? <CELinkNoAccess /> : <NoAccess /> },
        {
          path: ACCOUNT_ROUTES.BASE,
          element: isMobileSize ? <UserAccountScreen /> : <Navigate to={HOME_ROUTE} />,
        },
        { path: "/", element: <Navigate to={HOME_ROUTE} /> },
      ],
    },
    { path: "", element: <Navigate to={HOME_ROUTE} /> },
    { path: "*", element: <Navigate to={HOME_ROUTE} /> },
  ];

  return useRoutes(routes);
};

export default NoAccessRoutes;
